const detectVideo = () => {
  detectYouTube();

  function onYouTubeIframeAPIReady(uniqueKey) {
    const playerWrapper = document.querySelector(
      `.hero-slide:not(.slick-cloned) [data-player="${uniqueKey}"]`,
    );
    const playerElement = playerWrapper.querySelector('iframe, [data-replace]');
    const youtubeKey = playerWrapper
      .querySelector('[data-video-id]')
      .getAttribute('data-video-id');
    let player;
    window.YT.ready(function () {
      player = new window.YT.Player(playerElement, {
        videoId: youtubeKey,
        playerVars: {
          mute: 1,
          autoplay: 1, // Auto-play the video on load
          autohide: 1,
          disablekb: 1,
          controls: 0, // Hide pause/play buttons in player
          showinfo: 0, // Hide the video title
          modestbranding: 1, // Hide the Youtube Logo
          loop: 1, // Run the video in a loop
          fs: 0, // Hide the full screen button
          autohide: 1, // Hide video controls when playing
          rel: 0,
          enablejsapi: 1,
        },
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerStateChange,
        },
      });
    });
  }

  // 4. The API will call this function when the video player is ready.
  function onPlayerReady(e) {
    e.target.mute();
    e.target.playVideo();
    e.target.setPlaybackQuality('hd1080');
  }

  // 5. The API calls this function when the player's state changes.
  //    The function indicates that when playing a video (state=1),
  //    the player should play for six seconds and then stop.
  const done = false;

  function onPlayerStateChange(e) {
    if (e && e.data === 1) {
      const videoHolder = document.getElementById('home-banner-box');
      if (videoHolder && videoHolder.id) {
        videoHolder.classList.remove('loading');
      }
    } else if (e && e.data === 0) {
      e.target.playVideo();
    }
  }

  function stopVideo() {
    player.stopVideo();
  }

  const defaultVimeoOptions = {
    autoplay: true,
    loop: true,
    controls: true,
    muted: true,
    playsinline: true,
  };

  function embedVimeo(uniqueKey, options) {
    const playerOptions = {
      ...defaultVimeoOptions,
      ...options,
    };
    const playerWrapper = document.querySelector(
      `.hero-slide:not(.slick-cloned) [data-player="${uniqueKey}"]`,
    );
    const playerElement = playerWrapper.querySelector('iframe, [data-replace]');
    const vimeoKey = playerWrapper
      .querySelector('[data-video-id]')
      .getAttribute('data-video-id');

    const vimeoSelector = `select-${uniqueKey}`;
    playerElement.setAttribute('id', vimeoSelector);
    let player;
    if (
      (window.innerWidth > 768 && uniqueKey.includes('desktop')) ||
      (window.innerWidth <= 768 && uniqueKey.includes('mobile'))
    ) {
      player = new window.Vimeo.Player(vimeoSelector, {
        ...playerOptions,
        id: vimeoKey,
      });
    }

    return player;
  }

  function detectYouTube() {
    isLoaded.then(() => {
      $(document).ready(function () {
        const playerElements = document.querySelectorAll(
          `.hero-slide:not(.slick-cloned) [data-type="external_video"]`,
        );
        setTimeout(function () {
          for (const player of playerElements) {
            const uniqueKey = player.dataset.player;
            if (player.dataset.videotype == 'vimeo') {
              // Error in Vimeo API causing video not to work. Now using Iframe on banner-viddeo.liquid
              // embedVimeo(uniqueKey)
            } else {
              onYouTubeIframeAPIReady(uniqueKey);
            }
          }
        }, '500');
      });
    });
  }
};
/** insert youtube API */
var isLoaded = new Promise((res, rej) => {
  function include_once(url) {
    /*
         [additional code to check if 'url' was already included]
         */
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.onload = () => res();
    script.onerror = () => rej();
    script.src = url;
    document.head.appendChild(script);
  }
  include_once('https://www.youtube.com/iframe_api');
});

export default detectVideo;
